module.exports = __webpack_public_path__ + "img/sprites-payment-logo.c6967529.png";